export default __webpack_public_path__ + "static/mission-vision-values-a8e77cb0e63d89df313995fd56781fe0.webm";